// Pure helpers for the PO Creation reorder view. The server decides reasons and buckets; these
// only group, count and order what it sent (spec 2026-10-23 §9).
export const BUCKETS = [
    { key: 'ORDER_NOW', label: 'Order now' },
    { key: 'ORDER_SOON', label: 'Order soon' },
    // Spec 2026-11-01 F7: regions that stock already on our dock can fill — ship it, don't buy it.
    { key: 'SHIP', label: 'Ship from here' },
    { key: 'FIX', label: "Fix, don't order" },
    { key: 'WATCH', label: 'Watch' },
    { key: 'OK', label: 'OK' },
    { key: 'SKIPPED', label: 'Skipped' },
];

export const hasAdvice = (rows) => rows.some(r => r.bucket != null);

export const viewBucket = (row) => (row.skip ? 'SKIPPED' : row.bucket);

export function bucketSummary(rows) {
    const out = {};
    BUCKETS.forEach(b => { out[b.key] = { count: 0, dollars: 0 }; });
    rows.forEach(r => {
        const k = viewBucket(r);
        if (!out[k]) return;
        out[k].count += 1;
        if (r.suggestedOrderQty > 0 && r.priceListCost != null) out[k].dollars += r.suggestedOrderQty * r.priceListCost;
    });
    return out;
}

export function orderNowHandled(rows, selectedItems) {
    const now = rows.filter(r => r.bucket === 'ORDER_NOW');
    const unhandled = now.filter(r => !r.skip && !selectedItems[r.asin]).length;
    return { total: now.length, unhandled };
}

const localToday = () => {
    const d = new Date();
    const pad = (n) => String(n).padStart(2, '0');
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
};

// Spec 2026-11-01 F7: in Order now every order-by on or before today is equally "due now", so the
// held-sold-out region priority (not how long ago it was due) decides among them.
export function sortForBucket(rows, today = localToday()) {
    const due = (r) => (r.bucket === 'ORDER_NOW' && r.orderBy != null && r.orderBy <= today ? today : r.orderBy);
    return [...rows].sort((a, b) => {
        const ao = due(a), bo = due(b);
        if (ao !== bo) {
            if (ao == null) return 1;
            if (bo == null) return -1;
            return ao < bo ? -1 : 1;
        }
        // Spec 2026-11-01 F7: a region we held and sold out of first (lost sales), then its 30-day sales, then dollars.
        const pri = (b.regionPriority ?? -1) - (a.regionPriority ?? -1);
        if (pri !== 0) return pri;
        const sales = (b.outRegionSales30 ?? -1) - (a.outRegionSales30 ?? -1);
        if (sales !== 0) return sales;
        return (b.dollarsAtRisk ?? -Infinity) - (a.dollarsAtRisk ?? -Infinity);
    });
}
